import React, { useContext, useState, useEffect } from "react";
import {Container, Row, Col, Card,Form, Button, Modal} from "react-bootstrap";
import { User, Mail, Shield, Calendar, Lock, Edit, Save} from "lucide-react";
import AdminLayout from "../../../../layouts/admin/AdminLayout";
import "../../../../assets/css/admin/dashboardcss/AdminProfile.css";
import axios from "axios";
import AppContext from "../../../../context/AppContext";
import { useNavigate } from "react-router-dom";
import { checkLoggedInAdmin } from "../../../../helper/CustomHelper";
import Swal from "sweetalert2";

const AdminProfile = () => {
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
const navigate= useNavigate();
  // ______ Profile state ────
  const [id,             setId]             = useState();
  const [name,           setName]           = useState();
  const [email,          setEmail]          = useState();
  const [role,           setRole]           = useState();
  const [profilePicture, setProfilePicture] = useState(null);
  const [accountCreated, setAccountCreated] = useState();

  // Cache-busting version — image URL badalta hai taake browser purani
  // cached photo na dikhaye jab admin nayi photo upload kare
  const [avatarVersion, setAvatarVersion] = useState(Date.now());

  // ── Edit form state ────────────────────────────────────────────
  const [editName,  setEditName]  = useState("");
  const [editEmail, setEditEmail] = useState("");

  // ── Password form state ────────────────────────────────────────
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword,     setNewPassword]     = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // ── Modal visibility ───────────────────────────────────────────
  const [showEditModal,     setShowEditModal]     = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  // ── Load from localStorage ─────────────────────────────────────
  useEffect(() => {
    checkLoggedInAdmin(navigate);
    const admin = JSON.parse(localStorage.getItem("adminData"));
    if (admin) {
      setId(admin.id);
      setName(admin.name);
      setEmail(admin.email);
      setRole(admin.isSuperAdmin == 1 ? "Super Admin" : "Administrator");
      setProfilePicture(admin.image);
      setAccountCreated(admin.created_at);
    }
  }, []);

  // ── Avatar upload ──────────────────────────────────────────────
  // Sirf image bhejti hai, name/email nahi
  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("id",   id);
    formData.append("file", file);

    axios
      .post(`${baseUrl}/admin/profile/updateProfile`, formData)
      .then((response) => {
        if (response.data.success) {
          // Server se aaya actual path use karo (blob nahi)
          setProfilePicture(response.data.admin.image);
          // Naya version stamp → browser purani cached image nahi dikhayega
          setAvatarVersion(Date.now());

          // localStorage update karo
          localStorage.setItem(
            "adminData",
            JSON.stringify(response.data.admin)
          );

          Swal.fire({
            icon: "success",
            title: "Photo Updated!",
            text: "Profile picture updated successfully.",
            confirmButtonColor: "#e1788f",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Upload Failed!",
            text: response.data.message || "Unable to update profile picture.",
            confirmButtonColor: "#e1788f",
          });
        }
      })
      .catch((err) => {
        console.log(err);

        Swal.fire({
          icon: "error",
          title: "Upload Failed!",
          text:
            err.response?.data?.message ||
            "Unable to update profile picture. Please try again.",
          confirmButtonColor: "#e1788f",
        });
      });
  };

  // ── Edit profile ───────────────────────────────────────────────
  const handleEditOpen = () => {
    setEditName(name);
    setEditEmail(email);
    setShowEditModal(true);
  };

  const saveProfileChanges = () => {
    if (!editName || !editEmail) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Name and email are required.",
        confirmButtonColor: "#e1788f",
      });
      return;
    }

    const formData = new FormData();
    formData.append("id",    id);
    formData.append("name",  editName);
    formData.append("email", editEmail);

    axios
      .post(`${baseUrl}/admin/profile/updateProfile`, formData)

      .then((response) => {
  if (response.data.status) {
    setName(editName);
    setEmail(editEmail);

    localStorage.setItem(
      "adminData",
      JSON.stringify(response.data.admin)
    );

    setShowEditModal(false);

    Swal.fire({
      icon: "success",
      title: "Profile Updated!",
      text: response.data.message,
      confirmButtonColor: "#e1788f",
    });
  } else {
    Swal.fire({
      icon: "error",
      title: "Update Failed!",
      text: response.data.message || "Unable to update profile.",
      confirmButtonColor: "#e1788f",
    });
  }
})
 };
  //     .then((response) => {
  //       if (response.data.success) {
  //         // UI update karo
  //         setName(editName);
  //         setEmail(editEmail);

  //         // localStorage update karo (server se aaya admin object)
  //         localStorage.setItem(
  //           "adminData",
  //           JSON.stringify(response.data.admin)
  //         );

  //         setShowEditModal(false);

  //         Swal.fire({
  //           icon: "success",
  //           title: "Profile Updated!",
  //           text: response.data.message || "Your profile has been updated successfully.",
  //           confirmButtonColor: "#e1788f",
  //         });
  //       } else {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Update Failed!",
  //           text: response.data.message || "Unable to update profile.",
  //           confirmButtonColor: "#e1788f",
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);

  //       Swal.fire({
  //         icon: "error",
  //         title: "Update Failed!",
  //         text:
  //           err.response?.data?.message ||
  //           "Unable to update profile. Please try again.",
  //         confirmButtonColor: "#e1788f",
  //       });
  //     });
  // };

  // ── Change password ────────────────────────────────────────────
  const savePasswordChanges = () => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Please fill all password fields.",
        confirmButtonColor: "#e1788f",
      });
      return;
    }
    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "warning",
        title: "Passwords Don't Match",
        text: "New password and confirm password must be the same.",
        confirmButtonColor: "#e1788f",
      });
      return;
    }
    if (newPassword.length < 6) {
      Swal.fire({
        icon: "warning",
        title: "Weak Password",
        text: "Password must be at least 6 characters.",
        confirmButtonColor: "#e1788f",
      });
      return;
    }

    const formData = new FormData();
    formData.append("id",              id);
    formData.append("currentPassword", currentPassword);
    formData.append("newPassword",     newPassword);

    axios
      .post(`${baseUrl}/admin/profile/changePassword`, formData)
      .then((response) => {
        if (response.data.status) {
          // Fields clear karo
          setCurrentPassword("");
          setNewPassword("");
          setConfirmPassword("");

          setShowPasswordModal(false);

          Swal.fire({
            icon: "success",
            title: "Password Changed!",
            text: response.data.message || "Your password has been changed successfully.",
            confirmButtonColor: "#e1788f",
          });
        } else {
          // Wrong current password ya koi aur error
          Swal.fire({
            icon: "error",
            title: "Change Failed!",
            text: response.data.message || "Unable to change password.",
            confirmButtonColor: "#e1788f",
          });
        }
      })
      .catch((err) => {
        console.log(err);

        Swal.fire({
          icon: "error",
          title: "Change Failed!",
          text:
            err.response?.data?.message ||
            "Unable to change password. Please try again.",
          confirmButtonColor: "#e1788f",
        });
      });
  };

  // ── Render ─────────────────────────────────────────────────────
  return (
    <AdminLayout>
      <div className="sgc-ap-page">
        <Container fluid>

          {/* Page Header */}
          <div className="sgc-ap-header">
            <h2 className="sgc-ap-header-title">Admin Profile</h2>
            <p className="sgc-ap-header-sub">Manage your account settings</p>
          </div>

          <Row className="g-4">

            {/* LEFT: Profile Card */}
            <Col lg={4}>
              <Card className="sgc-ap-left-card">
                <Card.Body>

                  {/* Avatar */}
                  <div className="sgc-ap-avatar-wrap">
                    <div className="sgc-ap-avatar-ring">
                      <div className="sgc-ap-avatar-circle">
                        {profilePicture ? (
                          <img
                            src={`${baseUrlForFile}/${profilePicture}?v=${avatarVersion}`}
                            alt="Admin"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover"
                            }}
                          />
                        ) : (
                          <span className="sgc-ap-avatar-initials">
                            {name?.charAt(0) || "A"}
                          </span>
                        )}
                      </div>

                      {/* Camera button */}
                      <label
                        htmlFor="sgc-avatar-input"
                        className="sgc-ap-camera-btn"
                        title="Change photo"
                      >
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 15.2A3.2 3.2 0 1 0 12 8.8a3.2 3.2 0 0 0 0 6.4zm0-8.4A5.2 5.2 0 1 1 12 17.2 5.2 5.2 0 0 1 12 6.8zm-1-4.8h2l1.5 2H19a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4.5L11 2z" />
                        </svg>
                      </label>
                      <input
                        type="file"
                        id="sgc-avatar-input"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleAvatarChange}
                      />
                    </div>

                    <div className="sgc-ap-role-badge">
                      <Shield size={14} />
                      {role}
                    </div>
                  </div>

                  {/* Name & Email */}
                  <h3 className="sgc-ap-name">{name}</h3>
                  <p className="sgc-ap-email">{email}</p>

                  <hr className="sgc-ap-divider" />

                  {/* Quick Actions */}
                  <p className="sgc-ap-quick-title">Quick Actions</p>
                  <div className="sgc-ap-actions">
                    <button
                      className="sgc-ap-btn-update"
                      onClick={handleEditOpen}
                    >
                      <Edit size={16} /> Update Profile
                    </button>
                    <button
                      className="sgc-ap-btn-password"
                      onClick={() => {
                        setCurrentPassword("");
                        setNewPassword("");
                        setConfirmPassword("");
                        setShowPasswordModal(true);
                      }}
                    >
                      <Lock size={16} /> Change Password
                    </button>
                  </div>

                </Card.Body>
              </Card>
            </Col>

            {/* RIGHT: Account Info */}
            <Col lg={8}>
              <Card className="sgc-ap-right-card">
                <Card.Body>
                  <p className="sgc-ap-section-title">Account Information</p>
                  <hr className="sgc-ap-divider" />

                  <Row className="g-4 mt-1">
                    <Col md={6}>
                      <div className="sgc-ap-info-field">
                        <div className="sgc-ap-field-icon"><User size={18} /></div>
                        <div>
                          <span className="sgc-ap-field-label">Full Name</span>
                          <span className="sgc-ap-field-value">{name}</span>
                        </div>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="sgc-ap-info-field">
                        <div className="sgc-ap-field-icon"><Mail size={18} /></div>
                        <div>
                          <span className="sgc-ap-field-label">Email Address</span>
                          <span className="sgc-ap-field-value">{email}</span>
                        </div>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="sgc-ap-info-field">
                        <div className="sgc-ap-field-icon"><Shield size={18} /></div>
                        <div>
                          <span className="sgc-ap-field-label">Role</span>
                          <span className="sgc-ap-field-value">{role}</span>
                        </div>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="sgc-ap-info-field">
                        <div className="sgc-ap-field-icon"><Calendar size={18} /></div>
                        <div>
                          <span className="sgc-ap-field-label">Account Created</span>
                          <span className="sgc-ap-field-value">
                            {accountCreated
                              ? new Date(accountCreated).toLocaleDateString("en-GB")
                              : ""}
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Row>

                </Card.Body>
              </Card>
            </Col>

          </Row>
        </Container>

        {/* ── MODAL: UPDATE PROFILE ──────────────────────────────────── */}
        <Modal
          show={showEditModal}
          onHide={() => setShowEditModal(false)}
          centered
          className="sgc-ap-modal"
        >
          <Modal.Header closeButton className="sgc-ap-modal-header">
            <Modal.Title className="sgc-ap-modal-title">
              <Edit size={20} className="me-2" />Update Profile
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="sgc-ap-modal-body">
            <Form>
              <Form.Group className="mb-3">
                <Form.Label className="sgc-ap-form-label">Full Name</Form.Label>
                <Form.Control
                  type="text"
                  className="sgc-ap-form-control"
                  placeholder="Enter your full name"
                  value={editName}
                  onChange={(e) => setEditName(e.target.value)}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label className="sgc-ap-form-label">Email Address</Form.Label>
                <Form.Control
                  type="email"
                  className="sgc-ap-form-control"
                  placeholder="Enter your email"
                  value={editEmail}
                  onChange={(e) => setEditEmail(e.target.value)}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer className="sgc-ap-modal-footer">
            <Button
              type="button"
              className="sgc-ap-modal-btn-cancel"
              onClick={() => setShowEditModal(false)}
            >
              Cancel
            </Button>
            <Button
              type="button"
              className="sgc-ap-modal-btn-save"
              onClick={saveProfileChanges}
            >
              <Save size={16} className="me-2" />Save Changes
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ── MODAL: CHANGE PASSWORD ─────────────────────────────────── */}
        <Modal
          show={showPasswordModal}
          onHide={() => setShowPasswordModal(false)}
          centered
          className="sgc-ap-modal"
        >
          <Modal.Header closeButton className="sgc-ap-modal-header">
            <Modal.Title className="sgc-ap-modal-title">
              <Lock size={20} className="me-2" />Change Password
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="sgc-ap-modal-body">
            <Form>
              <Form.Group className="mb-3">
                <Form.Label className="sgc-ap-form-label">Current Password</Form.Label>
                <Form.Control
                  type="password"
                  className="sgc-ap-form-control"
                  placeholder="Enter current password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="sgc-ap-form-label">New Password</Form.Label>
                <Form.Control
                  type="password"
                  className="sgc-ap-form-control"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <Form.Text className="text-muted">Minimum 6 characters</Form.Text>
              </Form.Group>
              <Form.Group>
                <Form.Label className="sgc-ap-form-label">Confirm New Password</Form.Label>
                <Form.Control
                  type="password"
                  className="sgc-ap-form-control"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer className="sgc-ap-modal-footer">
            <Button
              type="button"
              className="sgc-ap-modal-btn-cancel"
              onClick={() => setShowPasswordModal(false)}
            >
              Cancel
            </Button>
            <Button
              type="button"
              className="sgc-ap-modal-btn-save"
              onClick={savePasswordChanges}
            >
              <Lock size={16} className="me-2" />Change Password
            </Button>
          </Modal.Footer>
        </Modal>

      </div>
    </AdminLayout>
  );
};

export default AdminProfile;